import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError } from '../lib/api';

/**
 * Forgot password — mirrors `.old/resources/views/auth/passwords/email.blade.php`
 * (Laravel's `password.request` view served at /password/reset on the live site).
 */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.post('/api/v1/auth/forgot-password', { email });
      setDone(true);
    } catch (err) {
      if (err instanceof ApiError) setError(`Request failed (${err.status}).`);
      else setError('Network error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="card">
        <div className="card-body p-4">
          <div className="text-center w-75 m-auto">
            <h4 className="text-dark-50 text-center mt-0 fw-bold">Reset Password</h4>
            <p className="text-muted mb-4">
              Please enter your email.
            </p>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}
          {done && (
            <div className="alert alert-success">
              If an account exists for <strong>{email}</strong>, a reset link has been sent. The link expires in 60 minutes.
            </div>
          )}

          {!done && (
            <form onSubmit={onSubmit} noValidate data-disable-unsaved-alert>
              <div className="mb-3">
                <label htmlFor="emailaddress" className="form-label">Email Address</label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  id="emailaddress"
                  required
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="mb-0 text-center">
                <button className="btn btn-primary" type="submit" disabled={submitting}>
                  {submitting ? 'Sending…' : 'Send Password Reset Link'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12 text-center">
          <p className="text-muted">
            Don't have an account?{' '}
            <Link to="/register" className="text-muted ms-1">
              <b>Sign Up</b>
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}
